class ErrorService {
  errRef: any = null;

  showError = (err: string, duration: number) => {
    this.errRef?.show?.(err, duration);
  };
}

export default new ErrorService();
